<template>
  <OSimpleEditDialog
    ref="dialog"
    strings="estoque;o"
    v-bind="dialogData"
    @reload="$emit('reload')"
  >
    <template v-slot="{ row }">
      <v-card-text class="pa-3 children-pa-3">
        <div>
          <v-text-field label="Nome" v-model="row.name" />
        </div>
      </v-card-text>
    </template>
  </OSimpleEditDialog>
</template>

<script>
import OSimpleEditDialog from 'oderon-vue/cpts/dialogs/OSimpleEditDialog.vue'
import { Depot } from '@/models'

export default {
  components: { OSimpleEditDialog },
  data() {
    return {
      dialogData: {
        fetchData: (id) => Depot.findById(id),
        // doDelete: (row) => Depot.delete(row.id),
        doSave: (row) => Depot.save(row)
      }
    }
  },
  methods: {
    open(id) {
      return this.$refs.dialog.open(id)
    }
  }
}
</script>

<style></style>
